import React from 'react';
import { ReactTinyLink } from 'react-tiny-link';

import { Space } from 'antd';

import styles from './Linkify.module.css';

export const Linkify: React.FC<{
  text: string;
  hasPreview: boolean;
  isHighlighted?: boolean;
}> = ({ text, hasPreview, isHighlighted }) => {
  // eslint-disable-next-line
  const regex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#%?=~_|!:,.;]*[-A-Z0-9+&@#%=~_|])/gi;

  const linkify = (text: string) => {
    return text
      .replace(/(\r\n|\n|\r)/g, '<br>')
      .replace(regex, "<a target='_blank' href='$1'>$1</a>");
  };

  /* Gets all the URLs from a text, returns an empty array if none was found */
  const match = (text: string) => {
    const matches = text.match(regex);
    return matches && matches.length > 0 && matches[0] !== '' ? matches : [];
  };

  /* Shows a preview of the link if hasPreview is true, otherwise just linkify the links */
  return text ? (
    <Space direction="vertical" size="large">
      <span
        className={isHighlighted ? styles.linkText : undefined}
        data-testid="linkify"
        dangerouslySetInnerHTML={{ __html: linkify(text) }}
      ></span>
      {hasPreview &&
        match(text).map(url => (
          <ReactTinyLink
            cardSize="small"
            showGraphic={true}
            maxLine={2}
            minLine={1}
            url={url}
          />
        ))}
    </Space>
  ) : null;
};
